/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import * as moment from 'moment';

/**
 * Datetime filter.
 *
 * Function used to return datetime formatted strings.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export default (value: number, time: boolean = true, date: boolean = true): string => {
    if (time && date) {
        return moment.unix(value).format('lll');
    }

    if (!time && date) {
        return moment.unix(value).format('ll');
    }

    return moment.unix(value).format('llll');
};
